import Resource from '../../api/resource'
import request from '../../utils/request';

class Case extends Resource {
    constructor() {
        super('cases');
    }


    changeStatus(payload){
        return request({
            url: `/cases/${payload.id}`,
            method: 'post',
            data:payload.query,
        });
    }


    export(payload){
        return request({
            url: `/cases/export`,
            method: 'post',
            responseType: "blob",
            data:payload,
        });
    }
    // removeDepartmentLink(payload) {
    //     return request({
    //         url: `/${this.uri}/remove-department-link`,
    //         method: 'post',
    //         data: payload,
    //     })
    // }


}

export {Case as default};
